import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Guyana Oil & Gas</h3>
            <p>
              Your comprehensive resource for Guyana's oil and gas industry. 
              Stay informed about the latest developments, opportunities, and insights.
            </p>
            <div className="social-links">
              <a href="#" className="social-link">Facebook</a>
              <a href="#" className="social-link">Twitter</a>
              <a href="#" className="social-link">LinkedIn</a>
            </div>
          </div>

          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/news">News</Link></li>
              <li><Link to="/vacancies">Vacancies</Link></li>
              <li><Link to="/history">History</Link></li>
              <li><Link to="/reserves">Reserves</Link></li>
              <li><Link to="/contractors">Contractors</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Resources</h4>
            <ul className="footer-links">
              <li><a href="https://www.naturalresources.gov.gy" target="_blank" rel="noopener noreferrer">Ministry of Natural Resources</a></li>
              <li><a href="https://www.epaguyana.org" target="_blank" rel="noopener noreferrer">Environmental Protection Agency</a></li>
              <li><a href="https://www.ggmc.gov.gy" target="_blank" rel="noopener noreferrer">Guyana Geology and Mines Commission</a></li>
              <li><a href="https://www.goga.gy" target="_blank" rel="noopener noreferrer">Guyana Oil and Gas Association</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Contact Us</h4>
            <div className="contact-info">
              <p><strong>Email:</strong> info@guyanaoilgas.gy</p>
              <p><strong>Phone:</strong> +592 225 1234</p>
              <p><strong>Address:</strong> Georgetown, Guyana</p>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; 2024 Guyana Oil & Gas. All rights reserved.</p>
            <div className="footer-bottom-links">
              <a href="#">Privacy Policy</a>
              <a href="#">Terms of Service</a>
              <a href="#">Sitemap</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
